<template>
  <div class="CompanyDynamics">
    <div class="content flex-jc-bt flex-no-wrap">
      <div class="flex-89 left-side">
        <sp-card type="none">
          <div class="card-content">
            <div class="buttons flex flex-al-center">
              <sp-button :class="{'mg-b-20': userType === 'CO' || userType === 'SO'}" to="addCompany" :width="0.12" :height="44" circle-radius="22" type="warn" :bold="400" :font="18" :label="$l('AddNewCompany')" />
              <sp-button v-if="userType !== 'CO' && userType !== 'SO'" class="mg-l-20" to="orgnizationChart" :width="0.12" :height="44" circle-radius="22" type="warn" :bold="400" :font="18" :label="$l('OrganizationChart')" />
              <sp-button v-if="userType !== 'CO' && userType !== 'SO'" class="mg-l-20" to="departmentDynamics" :width="0.15" :height="44" circle-radius="22" type="warn" :bold="400" :font="18" :label="$l('DepartmentDynamics')" />

              <!--              <FilterForm :company-category="companyCategory" /> -->
            </div>
            <sp-tag-group v-if="userType !== 'CO' && userType !== 'SO'" v-model="companyClass" class="tags">
              <sp-tag label="all" :width="100">{{ $l('All') }}</sp-tag>
              <sp-tag label="master">{{ $l('GeneralCompany') }}</sp-tag>
              <sp-tag label="sub">{{ $l('Subsidiary') }}</sp-tag>
              <sp-tag label="special">{{ $l('SomeSpecialCompanies') }}</sp-tag>
              <sp-tag label="deleted">{{ $l('Deleted') }}</sp-tag>
            </sp-tag-group>

            <SpTable v-model:currPage="currPage" :show-arrow="(userType ==='CO' || userType === 'SO') ? false : true"
                     column-height="114" :data-list="dataList" width="1"
                     class="table" :total="total" :page-size="pageSize" @afterExpand="getComDeptHistory">
              <SpTableColumn column-name="id" label="No" />
              <SpTableColumn label="LinkedOCNode">
                <template #default="row">
                  {{ row.node?.title }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="serialNo" label="CompanySerialNo" :ellipse="true" width="240" />
              <SpTableColumn column-name="codeName" label="CodeName" width="160">
                <template #default="row">
                  {{ row.codeName }}
                </template>
              </SpTableColumn>
              <SpTableColumn class="column" column-name="name" label="CompanyName">
                <template #default="row">
                  <SpTooltip>
                    <div class="column-main ellipsis">{{ row.name }}</div>
                    <div class="column-attach ellipsis">{{ row.nativeName }}</div>
                  </SpTooltip>
                </template>
              </SpTableColumn>
              <!-- <SpTableColumn column-name="CompanyNameC" /> -->
              <SpTableColumn column-name="CountryOrSAR" width="170">
                <template #default="row">
                  {{ row.regCountry?.name }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="CompanyCategory">
                <template #default="row">
                  <p v-if="row.privSign">Signing right company</p>
                  <p v-else>NIL</p>
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="AccessIdentity" width="180">
                <template #default="row">
                  <span>{{ $l(companyCategory[row.identity]?.title) }}</span>
                </template>
              </SpTableColumn>
              <SpTableColumn label="Staff" column-name="staffCount" />
              <SpTableColumn column-name="More">
                <template #default="row">
                  <SpIcon :ref="'more'+row.$index" class="pointer" type="more" @click="showMoreDialog(row.$index,$event)" />
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Action" :fixed="true" :width="companyClass=='deleted' ? 100 : 80">
                <template #default="row">
                  <div v-if="companyClass=='deleted'" class="flex-jc-ard">
                    <el-popover
                      trigger="click" inline width="500" height="200" @show="getDeleter(row)">
                      <template #reference>
                        <SpIcon type="deleteBy" class="mg-r-10" />
                      </template>
                      <DeleteBy :info="delInfo" />
                    </el-popover>

                    <SpIcon class="mg-r-10" type="cancel" @click="toRecycle(row)" />
                    <SpIcon type="delete" @click="toDelete(row)" />
                  </div>
                  <div v-else class="flex-jc-ard">
                    <SpIcon v-if="row.creatorId === userId " type="edit" @click="toEditPage(row)" />
                    <SpIcon v-if="row.creatorId !== userId " type="edit" style="opacity: 0.6; cursor: not-allowed" />
                    <SpIcon v-if="userType !=='CO' && userType !== 'SO'" type="delete" @click="toDelete(row)" />
                  </div>
                </template>
              </SpTableColumn>
              <template v-if="userType !=='CO' && userType !== 'SO'" #expand="row">
                <div class="expand flex">
                  <div v-if="row.level === ENTERPRISE_SUB">
                    <div class="expand-item sp-color-2">{{ $l('DepartmentsAvailable')+' ('+row.departments?.length+')' }}</div>

                    <!--                    <div class="progress-bar" :class="{'blue' : row.departments?.length >0}" /> -->
                    <sp-popover :width="800">
                      <SpTable v-if="row.depts" :data-list="row.depts" border="manul" class="popover-table" type="none" :pop-data-style="{borderBottom:'1px solid #DBDBDB'}">
                        <SpTableColumn column-name="Staff" width="300" label="deptName">
                          <template #default="crow">
                            <div class="ellipsis pd-l-10 pd-l-10">{{ crow.name }}</div>
                          </template>
                        </SpTableColumn>
                        <SpTableColumn column-name="JobDescription" :width="300" label="CompanyName">
                          <template #default="crow">
                            <div class="pd-l-10 pd-l-10">
                              <div class="ellipsis">
                                {{ row.name }}
                              </div>
                              <div class="attach" style="opacity: 0.6">
                                {{ row.nativeName }}
                              </div>
                            </div>
                          </template>
                        </SpTableColumn>
                        <SpTableColumn column-name="StartingDate" label="DateTime">
                          <template #default="row">
                            {{ getDateToFormatEn(row.createdAt) }}
                          </template>
                        </SpTableColumn>
                      </SpTable>
                      <template #reference>
                        <SpProgress :progress="row.departments?.length > 0 ? 1 : 0" />
                        <router-link class="expand-item sp-color-2" :to="{name: 'addDepartment', query: {nodeId: row.nodeId}}">{{ $l('AddNewDepartment') }}</router-link>
                      </template>
                    </sp-popover>

                    <!--                    <router-link class="expand-item sp-color-2" :to="{name: 'addDepartment', query: {nodeId: row.nodeId}}">{{ $l('AddNewDepartment') }}</router-link> -->
                  </div>
                </div>
              </template>
            </SpTable>
          </div>
        </sp-card>
      </div>
      <div class="flex-10 right-side" :style="(userType === 'CO' || userType === 'SO') ? 'padding-top: 59px; margin-top:64px': 'padding-top: 99px; margin-top: 70px'">
        <SpTable :data-list="dataList" width="1" class="table" column-height="114">
          <SpTableColumn column-name="EnteredBy">
            <template #default="row">
              <div>{{ row.creatorName }}</div>
              <!--              {{ $FormatDate() }} -->
              <div class="column-attach">
                {{ getDateToFormatEn(row.sourceCreatedAt) }}
              </div>
            </template>
          </SpTableColumn>
          <template v-if="userType !=='CO' && userType !== 'SO'" #expand>
            <div class="expand" />
          </template>
        </SpTable>
      </div>
      <SpDrawer v-model="showMore" dragable :offset-top="20" width="0.9" height="0.8">
        <CompanyDetail :id="checkItem.id" />
      </SpDrawer>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getEnterpriseCorpOwnedApi,
  trashEnterpriseCorpApi,
  deleteEnterpriseCorpApi,
  recycleEnterpriseCorpApi, getEnterpriseCorpDetailApi
} from '@/request/APIs/company'
import spCard from '@/components/common/SpCard'
import spButton from '@/components/common/SpButton'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
// import spTable from '@/components/common/SpTable'
import spPopover from '@/components/common/SpPopover'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import SpTable from '@/components/common/SpTableDIY/SpTable.vue'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn.vue'
import SpTooltip from '@/components/common/SpTooltip.vue'
import SpIcon from '@/components/common/SpIcon.vue'
import SpDivider from '@/components/common/SpDivider.vue'
import CompanyDetail from '@/components/company/companyDynamics/CompanyDetail'
import SpDrawer from '@/components/common/SpDrawer'
import FilterForm from './FilterForm'
import SpMessage from '@/components/common/SpMessage'
import SpDialog from '@/components/common/SpDialog'
import { getDateToFormatEn } from '@/utils/convert'

import { ACCESS_IDENTITY, COMPANY_CATEGORY, COMPANY_POSITION, ENTERPRISE_SUB } from '@/config/company'
import DeleteBy from '@/components/company/DeleteBy'
import { getDeleterInfoApi } from '@/request/APIs/common'
import _debounce from 'lodash/debounce'
import SpProgress from '@/components/common/SpProgress'

export default {
  name: 'CompanyDynamics',

  nameSpace: 'company.CompanyDynamics',
  components: {
    SpProgress,
    DeleteBy,
    FilterForm,
    spCard,
    spButton,
    spTag,
    spTagGroup,
    // spTable,
    spPopover,
    spSelect,
    spSelectOption,
    SpTable,
    SpTableColumn,
    SpTooltip,
    SpIcon,
    SpDivider,
    CompanyDetail,
    SpDrawer
  },

  props: {
  },

  data () {
    return {
      filterVisible: false,
      companyClass: 'all',
      checkItem: {},
      showMore: false,
      popupTrigger: 0,
      currPage: 1,
      total: 0,
      pageSize: 0,
      dataList: [],

      companyCategory: ACCESS_IDENTITY,

      companyPosition: COMPANY_POSITION,
      ENTERPRISE_SUB,
      getDateToFormatEn,
      delInfo: {}
    }
  },

  computed: {
    userType () {
      return this.$store.getters['user/getUserType']
    },

    userId () {
      return this.$store.state.user.user.id
    }
  },

  watch: {
    currPage (n) {
      this.getListing()
    },

    companyClass () {
      this.currPage = 1
      this.getListing()
    }
  },

  created () {
    this.getListing()
  },

  mounted () {
  },

  methods: {
    handleCheck (row) {
      // console.log(row)
      // const $table = this.$refs.table
      // $table.toggleRowExpansion(row)
      // $table.toggleRowSelection(row)
    },

    getListing () {
      getEnterpriseCorpOwnedApi(this.companyClass, this.currPage).then(res => {
        this.dataList = res.data.data
        this.total = res.data.total
        this.pageSize = res.data.pageSize
      })
    },

    showMoreDialog (index, e) {
      this.popupTrigger = index
      this.checkItem = this.dataList[index]
      this.showMore = true
    },

    // 跳转到编辑页面
    toEditPage (item) {
      this.$router.push({
        name: 'addCompany',
        query: { id: item.id, nodeId: item.nodeId, nodeType: item.level }
      })
    },

    // 删除公司
    toDelete (row) {
      SpDialog.Confirm({
        title: this.$l('tip'),
        content: this.$l('Delete Confirm'),
        height: 160,
        width: 300,
        callback: (code) => {
          if (code === 1) {
            let api = trashEnterpriseCorpApi
            if (this.companyClass === 'deleted') {
              api = deleteEnterpriseCorpApi // 强制删除
            }
            api(row.id).then(res => {
              SpMessage({
                message: res.message,
                type: 'success'
              })
              this.getListing()
            })
          }
        }
      })
    },

    // 恢复删除的公司
    toRecycle (row) {
      recycleEnterpriseCorpApi(row.id).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
        this.getListing()
      })
    },

    getDeleter: _debounce(function (row) {
      this.delInfo = {}
      getDeleterInfoApi('corp', row.id, row.employerId).then(res => {
        if (res.code > 0) {
          this.delInfo = res.data
        }
      })
    }, 300),

    getComDeptHistory (row, index) {
      getEnterpriseCorpDetailApi(row.id).then(res => {
        this.dataList[index].depts = res.data.departments
        // this.dataList[index].dismissed = res.data.dismissed
        // this.dataList[index].inService = res.data.inService
      })
    }
  }

}
</script>

<style scoped lang="less">
.filter-select{
  width: 100%;
}
.CompanyDynamics{
  position:relative;
  // overflow: hidden;
  .content{
    padding: @gap*2 @gap @gap @gap;
    .column-attach{
      font-weight: 400;
      opacity: 0.6;
      margin: 0;
    }
    .left-side{
      overflow: hidden;
      .card-content{
        padding: @gap 0 @gap @gap;
        position: relative;
        // overflow: hidden;
        .tags{
          margin-top: @gap;
        }
      }
      .table{
        font-weight: bold;
        color: black;
        margin-top: @gap;
        .column-main{
          margin: 0;
        }

        .expand-item{
          opacity: 0.5;
          font-weight: normal;
        }
        .progress-bar{
          width: 191px;
          height: 9px;
          background: #f2f2f2;

          margin: @gap/2 0 @gap/2 0;
          &.blue {
            background: #72BEDE;
          }
        }
      }
    }
    .right-side{
      background-color: white;
      padding: 99px @gap @gap @gap;
      margin: @gap*3+10 @gap @gap @gap;
    }
  }
  .expand{
    padding:@gap;
    height:60px;
  }
}
</style>
